import { Link } from 'react-router-dom';
import { useBasketStore } from '@/stores/basket';

/**
 * Persistent basket icon with item count badge.
 * Shown in the navigation header for authenticated members.
 * Clicking navigates to the merchandise basket page.
 */
export function BasketIcon() {
  const { itemCount } = useBasketStore();

  const href = '/members/shop/basket';

  return (
    <Link
      to={href}
      className="relative p-2 text-gray-300 hover:text-white transition-colors rounded-lg hover:bg-gray-800"
      aria-label={`Shopping basket${itemCount > 0 ? `, ${itemCount} item${itemCount !== 1 ? 's' : ''}` : ''}`}
    >
      {/* Shopping bag icon */}
      <svg
        className="w-6 h-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 10H4L5 9z"
        />
      </svg>

      {/* Item count badge */}
      {itemCount > 0 && (
        <span
          className="absolute -top-1 -right-1 flex items-center justify-center w-5 h-5 text-xs font-bold bg-gold text-pce-black rounded-full leading-none"
          aria-hidden="true"
        >
          {itemCount > 99 ? '99+' : itemCount}
        </span>
      )}
    </Link>
  );
}
